import React from "react";

const iconStroke = "#4F46E5";

export const targetAudienceContent = {
  heading: "Built for Recruiters & Job Consultants",
  description:
    "Whether you're a small agency or large firm, we help you skip the manual grind and stay updated daily.",
  cta: {
    text: "Start Your 14 Day Free Trial",
  },
};

export const audiences = [
  {
    icon: (
      <svg
        className="h-6 w-6"
        fill="none"
        stroke={iconStroke}
        viewBox="0 0 24 24"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        />
      </svg>
    ),
    title: "Small Agencies",
    description:
      "Perfect for consultants handling 50-200 jobs per month with limited staff.",
  },
  {
    icon: (
      <svg
        className="h-6 w-6"
        fill="none"
        stroke={iconStroke}
        viewBox="0 0 24 24"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4 5a1 1 0 011-1h14a1 1 0 011 1v14a1 1 0 01-1 1H5a1 1 0 01-1-1V5z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4 12h16M12 4v16"
        />
      </svg>
    ),
    title: "Mid-Size Firms",
    description:
      "Scale your operations with team access and advanced filtering capabilities.",
  },
  {
    icon: (
      <svg
        className="h-6 w-6"
        fill="none"
        stroke={iconStroke}
        viewBox="0 0 24 24"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
        />
      </svg>
    ),
    title: "Large Enterprises",
    description:
      "Unlimited access with custom integrations and dedicated account management.",
  },
];
